export default class KeySequenceHandler {
  constructor(timeoutDuration = 1000) {
    this.keySequence = []
    this.sequenceTimeout = null
    this.timeoutDuration = timeoutDuration
  }

  handle(event, keyBindings) {
    if (event.metaKey || event.ctrlKey || event.altKey) {
      this.resetSequence()
      return false
    }

    const key = event.key.toUpperCase()
    const sequences = Object.keys(keyBindings)
    const combo = [...this.keySequence, key].join('')
    const matched = sequences.includes(combo)
    const partial = !matched && sequences.some(sequence => sequence.startsWith(combo))

    if (matched) {
      event.preventDefault()
      this.resetSequence()
      keyBindings[combo]()
      return true
    }

    if (partial) {
      this.keySequence.push(key)
      this.restartSequenceTimer()
    } else {
      this.resetSequence()
    }

    return false
  }

  restartSequenceTimer() {
    if (this.sequenceTimeout) clearTimeout(this.sequenceTimeout)
    this.sequenceTimeout = setTimeout(() => this.resetSequence(), this.timeoutDuration)
  }

  resetSequence() {
    this.keySequence = []
    if (this.sequenceTimeout) {
      clearTimeout(this.sequenceTimeout)
      this.sequenceTimeout = null
    }
  }

  cleanup() {
    this.resetSequence()
  }
}
